export default __webpack_public_path__ + "static/media/BarnPin.9bc42e1d.svg";